import React, { useEffect, useState } from "react";
import { Table, Image } from "react-bootstrap";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

export const LiveStreamingPageComponent = (props) => {
  const [video, setVideo] = useState([]);

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return item?.restaurant_id?.restaurant_name
        ?.toLowerCase()
        .includes(props.search.toLowerCase());
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // }

  // useEffect(() => {
  //   // console.log(props.data);
  //   if (props.data) {
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setVideo(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "15%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Social media <br />
              Platform
            </th>
            <th style={{ width: "30%" }} className="f12-700">
              Link
            </th>
            <th style={{ width: "20%" }} className="f12-700">
              Area of
              <br />
              Facility
            </th>
            <th style={{ width: "20%" }} className="f12-700">
              Viewed
            </th>
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {filteredData.map((video, index) => (
          <tbody className="HideShowTable" key={index}>
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "15%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      src={
                        (video &&
                          video.restaurant_id &&
                          video.restaurant_id.logo_url) ||
                        NOTAVAILABLEIMAGE
                      }
                      alt="Restaurant logo"
                      title="Restaurant logo"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {video &&
                      video.restaurant_id &&
                      video.restaurant_id.restaurant_name}{" "}
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-500">{video.media}</div>
              </td>
              <td style={{ width: "30%" }}>
                <div className="f14-500">{video.link}</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f14-500">{video.area}</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f14-500">{video.viewed ? "Yes" : "No"}</div>
                <div className="f14-400">
                  {moment(video.createdAt).format("DD MMM,YYYY")}
                  <br />
                  {moment(video.createdAt).format("LT")}
                </div>
              </td>
            </tr>
          </tbody>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};
